exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.single-quesion-box[data-v-03b5f7d3] {\n  margin-bottom: 15px;\n}\n", ""]);

// exports
